// import React from 'react';
// import loadable from '@loadable/component';

// const CardsListComponent = (props) => {
//   const Component = loadable(() => import('./Component.js'), { ssr: false });
//   return <Component {...props} />;
// };

// export default CardsListComponent;

import React, { useEffect, useMemo, useState } from 'react';
import './style.scss';
import CardsListHeader from './shared/header';
import CardsListStickyCompareBar from './shared/StickyCompareBar';
import CardsListGridView from './shared/gridView';
import CardsListListView from './shared/listView';
import CardsListCompareTable from './shared/CompareTable';
import useWindowSize from '../Shared/hooks/useWindowSize';
import { useHistory, useLocation } from 'react-router-dom';
import { transformCardsFeatures, useSelect } from './utils';
import clsx from 'clsx';
import CardsListCarouselView from './shared/carousel/index.js';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { withTranslation } from 'react-i18next';

const CardsListActualComponent = (props) => {
  const { heading, text, items } = props?.fields;
  const { CardsDisplay: displayMode, Styles, theme, carouselMode, dontShowCompare } = props.params;
  const darkMode = theme !== 'lightMode';
  const isCarousel = carouselMode === '1';
  const [isGrid, setIsGrid] = useState(displayMode !== 'List');
  const { language } = props.i18n;
  //SELECT
  const [sizeX] = useWindowSize();
  const selectLimit = useMemo(() => (sizeX > 1024 ? 3 : 2), [sizeX]);
  const cards = transformCardsFeatures(items);
  const [selectedIds, selectCard, unselectCard, unselectAll, getSelectedCards] = useSelect(items);
  //COMPARE
  const history = useHistory();
  const location = useLocation();
  //REWARDS
  const [rewardsOpenedFor, setRewardsOpenedFor] = useState(null);

  useEffect(() => {
    setRewardsOpenedFor(null);
  }, [isGrid]);

  useEffect(() => {
    const cardCount = selectedIds.length;
    //For mobile version triggering compare events
    if (sizeX <= 1024 && cardCount >= 2) {
      handleCompare();
    }
  }, [selectedIds]);
  const openRewards = (cardId) => {
    setRewardsOpenedFor((prev) => {
      if (prev === cardId) return null;
      return cardId;
    });
  };

  const canSelect = () => selectedIds.length < selectLimit;

  const handleCompare = () => {
    const params = getSelectedCards()
      .map((card) => card.id)
      .join(',');
    history.push(location.pathname + `?comparedCards=${params}`);
  };
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CardsList" />;
  }
  return (
    <div
      className={clsx(
        'cards-list-component',
        darkMode && 'cards-list-component-dark',
        'add-margins',
        Styles
      )}
    >
      <CardsListCompareTable cards={cards} />
      {sizeX > 1024 && (
        <CardsListStickyCompareBar
          cards={getSelectedCards()}
          unselectAll={unselectAll}
          unselectCard={unselectCard}
          cardsAmount={selectLimit}
          onCompare={handleCompare}
        />
      )}
      <CardsListHeader
        heading={heading}
        text={text}
        isGrid={isGrid}
        setIsGrid={setIsGrid}
        disableSwitch={displayMode !== 'Both'}
        darkMode={darkMode}
      />
      {!isGrid ? (
        <CardsListListView
          language={language}
          sizeX={sizeX}
          cards={cards}
          selectCard={selectCard}
          cardsSelected={selectedIds}
          selectable={canSelect()}
          openRewards={openRewards}
          rewardsOpenedFor={rewardsOpenedFor}
          dontShowCompare={dontShowCompare}
          setRewardsOpenedFor={setRewardsOpenedFor}
          t={props?.t}
        />
      ) : !isCarousel ? (
        <CardsListGridView
          sizeX={sizeX}
          darkMode={darkMode}
          cards={cards}
          selectCard={selectCard}
          cardsSelected={selectedIds}
          selectable={canSelect()}
          openRewards={openRewards}
          rewardsOpenedFor={rewardsOpenedFor}
          dontShowCompare={dontShowCompare}
          t={props?.t}
        />
      ) : (
        <CardsListCarouselView
          sizeX={sizeX}
          cards={cards}
          selectCard={selectCard}
          cardsSelected={selectedIds}
          selectable={canSelect()}
          openRewards={openRewards}
          setRewardsOpenedFor={setRewardsOpenedFor}
          rewardsOpenedFor={rewardsOpenedFor}
          darkMode={darkMode}
          dontShowCompare={dontShowCompare}
          t={props?.t}
        />
      )}
      {sizeX <= 1024 && (
        <CardsListStickyCompareBar
          cards={getSelectedCards()}
          unselectAll={unselectAll}
          unselectCard={unselectCard}
          cardsAmount={selectLimit}
          onCompare={handleCompare}
        />
      )}
    </div>
  );
};

export default withTranslation()(CardsListActualComponent);

